<template>
  <v-row justify-center>
    <v-dialog :value="value" @input="$emit('input')" max-width="800">
      <p>{{ this.description }}</p>
      <v-img v-bind:src="imagen"></v-img>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    value: Boolean,
    imgId: String,
    imgUrl: String,
    description: String
  },
  data () {
    return {
      imagen: null
    }
  },
  async created () {
    // this.imagen = this.imgUrl
  },
  methods: {
    ...mapActions({
      getDocumentsById: 'incidencias/getDocumentsById',
    }),
    getImage() {
      this.getDocumentsById(this.imgId)
        .then(() => {
          this.imagen = 'data:image/*;base64,' + this.singleDoc[0].document.toString().replace(/(\r\n|\n|\r)/gm ,'')
        })
        .catch(e => {
          return e
        })
    }
  },
  watch: {
    async imgUrl(){
      this.imagen = this.imgUrl
      // vamos a recargar la imagen pero en grande
      this.getImage()
      console.log('cambia la imagen')
    }
  },
  computed: {
    singleDoc() {
      return this.$store.state.incidencias.singleDoc
    }
  }
}
</script>

<style scoped>
p {
  font-size: 22px;
  color: black;
  font-weight: bold;
  text-align: center;
  padding: .8em;
  margin-bottom: 0px !important;
  background-color: rgb(255, 255, 255) !important;
}
</style>